import type { IconData } from '@stacksjs/iconify-core'

export const musicSpeaker: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.475 1.525H1.525v28.95h28.95Zm-1.52 27.43H12.2V3.045h16.76Z\"/><path fill=\"currentColor\" d=\"M25.905 25.905h1.53v1.53h-1.53Zm0-9.14h1.53v6.09h-1.53Zm0-12.19h1.53v1.52h-1.53Zm-1.52 18.28h1.52v1.53h-1.52Zm0-7.62h1.52v1.53h-1.52Zm-1.53 3.05h1.53v3.05h-1.53Zm0-10.66h1.53v3.04h-1.53Zm-4.57 16.76h6.1v1.52h-6.1Zm1.53-7.62h3.04v1.52h-3.04Zm0-10.67h3.04v1.53h-3.04Zm0 15.24h3.04v1.52h-3.04Zm-1.53-7.62h6.1v1.52h-6.1Zm1.53-3.05h3.04v1.53h-3.04Zm-1.53 7.62h1.53v3.05h-1.53Zm0-10.66h1.53v3.04h-1.53Zm-1.52 15.23h1.52v1.53h-1.52Zm0-7.62h1.52v1.53h-1.52Zm-1.52 1.53h1.52v6.09h-1.52Zm-1.53 9.14h1.53v1.53h-1.53Zm0-21.33h1.53v1.52h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default musicSpeaker
